import { ReportEntry } from "../@types/ReportEntry";
import { Status } from "../enums/Status";
import Collaborator from "../@types/Collaborator";

export const canViewRefusedReason = (data: ReportEntry) => {
  return data.reportEntryStatus === Status.REFUSED || data.refusedByFinancial || data.refusedByOwner;
};

export const canViewApprovedReasonPerFinancial = (data: ReportEntry) => {
  return data.approvedByFinancial;
};

export const canViewApprovedReasonPerManager = (data: ReportEntry) => {
  return data.approvedByOwner;
};

export const hasComments = (data: ReportEntry) => {
  return data.financialApprovedReason || data.ownerApprovedReason || data.refusedReason;
};

export function canRepprove(loggedUser: Collaborator | undefined, data: ReportEntry) {
  return (
    (loggedUser?.isApprover || loggedUser?.financialSupport) &&
    (data.reportEntryStatus == Status.ON_APPROVAL || data.reportEntryStatus == Status.APPROVED)
  );
}

export function canApprovePerManager(data: ReportEntry, loggedUser: Collaborator | undefined) {
  return data.reportEntryStatus == Status.ON_APPROVAL && loggedUser?.financialSupport && data.approvedByOwner == null;
}

export function canApproveEntry(data: ReportEntry, loggedUser: Collaborator | undefined) {
  return (
    data.reportEntryStatus == Status.ON_APPROVAL &&
    ((loggedUser?.financialSupport && data.approvedByFinancial == null) ||
      (loggedUser?.isApprover && !loggedUser?.financialSupport && data.approvedByOwner == null))
  );
}

export function canMarkAsPaid(loggedUser: Collaborator | undefined, data: ReportEntry) {
  return loggedUser?.financialSupport && 
         (data.reportEntryStatus == Status.FINANCIAL_VALIDATION || 
          data.reportEntryStatus == Status.APPROVED);
}

export function canSendForFinancialValidation(loggedUser: Collaborator | undefined, data: ReportEntry) {
  return loggedUser?.financialSupport && data.reportEntryStatus == Status.APPROVED;
}

export function canEditReportEntry(data: ReportEntry, loggedUser: Collaborator | undefined) {
  return data.collaborator == loggedUser;
}

export function canReturnToApproval(loggedUser: Collaborator | undefined, data: ReportEntry) {
  return (
    loggedUser?.financialSupport &&
    (data.reportEntryStatus == Status.FINANCIAL_VALIDATION || data.reportEntryStatus == Status.PAID)
  );
}

export function canMarkAsPaidForAdvance(loggedUser: Collaborator | undefined, data: ReportEntry) {
  // Botão só aparece para usuários do financeiro, em adiantamentos aprovados
  return (
    loggedUser?.financialSupport && 
    data.isAdvance && 
    data.reportEntryStatus === Status.APPROVED
  );
}

export function canConfirmAdvanceReceipt(loggedUser: Collaborator | undefined, data: ReportEntry) {
  // Verificar se é um adiantamento de múltiplas formas
  const isAdvance = data.isAdvance === true || 
                   data.advanceRefund === true || 
                   (data.description && data.description.toLowerCase().includes('adiantamento')) ||
                   (data.expendCategory && data.expendCategory.toLowerCase().includes('advance'));
  
  return (
    data.reportEntryStatus == Status.PAID && 
    isAdvance && 
    data.collaborator.id === loggedUser?.id
  );
}

